<template>
  <main class="task-page">
    <form @submit.prevent="newTask">
      <MainButton :button-text="$t(`taskPage.createTask`)"
                  type="submit"
                  style="height:50px;margin:1rem; width:200px"
      />
    </form>
    <div class="container" />
    <div style="margin-left: 10px;">
      <PaginatedList :tasks="tasks"
                     :table-columns="['Nr', 'Priority', 'TaskDescription', 'Status', 'Owner', 'CreatedBy', 'PlannedDate', 'Object1']"
                     :loading="isLoading"
                     :current-page="currentPage"
                     :total-pages="totalPages"
                     :total-count="totalCount"
                     :page-size="pageSize"
                     @update="fetchTasks"
      />
    </div>
  </main>
</template>

<script setup>
import PaginatedList from '@/components/task/PaginatedList.vue'
import i18n from '../locales/i18n'
import { onMounted, computed, ref } from 'vue'
import { useStore } from 'vuex'
import router from '@/router'
import MainButton from '@/components/buttons/MainButton.vue'
// VueX
const store = useStore()

const isLoading = ref(false)
const tasks = computed(() => store.state.task.tasks)

const currentPage = ref(1)
const totalPages = ref(1)
const totalCount = ref(0)
const pageSize = ref(20)
const sortColumnApiMapping = {
  CreatedBy: 'CB.Name',
  Status: 'T.Status',
  Object1: 'O.Name',
  Owner: 'T.OwnerSign',
  Priority: 'T.Priority',
  TaskDescription: 'SE.Value'
}

const fetchTasks = async ({ page, pageSize: sizeParam, sortColumn, sortOrder, statuses }) => {
  isLoading.value = true
  try {
    await store.dispatch('task/getBaseData', {
      orderBy: sortColumnApiMapping[sortColumn] || sortColumn,
      descending: sortOrder === 'desc',
      page: page - 1,
      pageSize: sizeParam,
      taskStatuses: statuses
    })
    currentPage.value = page
    const totalCountStore = store.state.task.totalCount
    console.log(totalCountStore)
    pageSize.value = sizeParam
    totalPages.value = Math.ceil(totalCountStore / pageSize.value)
    totalCount.value = totalCountStore
  } finally {
    isLoading.value = false
  }
}
onMounted(async () => {
  await fetchTasks({ page: 0, pageSize: pageSize.value, sortColumn: 'PlannedDate', sortOrder: 'asc', statuses: [0, 1, 2, 3, 4, 5] })

  store.commit('sidebar/setCurrentPageHeaderText', i18n.global.t('taskPage.Task'))
})

function newTask () {
  router.push('/create/task/')
}

</script>

<style lang="scss" scoped>
.pagination {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 0.5rem;
  margin: 1rem;

  button {
    padding: 0.5rem 1rem;
    background-color: var(--mainBlue);
    color: white;
    border: none;
    cursor: pointer;
    border-radius: 4px;
    font-weight: 500;
  }

  button.active {
    background-color: #005bb5;
    font-weight: bold;
  }

  button:disabled {
    background-color: #ccc;
    cursor: not-allowed;
  }
}
.pagination-controls {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 0.5rem;
  gap: 0.5rem;
  font-weight: 500;

  select {
    padding: 0.4rem 0.6rem;
    border-radius: 4px;
    border: 1px solid #ccc;
    font-family: inherit;
    font-size: 0.95rem;
  }
}
.task-page {
  height: 100vh;
  overflow-y: scroll;
  text-align: center;
  color: #2c3e50;
  background: white;
}

.container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 1rem;
  min-width: unset;
  width: 1;
}
.task-list-wrapper {
  position: relative;
  width: 100%;
}

.styled-table {
  table-layout: fixed;
  border-collapse: collapse;
  margin: 5px 0;
  font-size: 0.9em;
  width: 100%;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.5);
}

.styled-table thead tr {
  background-color: var(--mainBlue);
  color: white;
  text-align: left;
}

.styled-table th {
  padding: 12px 15px;
  text-align: left;
}

.styled-table tbody tr {
  border-bottom: 1px solid lightgrey;
  background-color: white;
  color: black;
}

.styled-table tbody tr:nth-of-type(4n-1),
.styled-table tbody tr:nth-of-type(4n) {
  background-color: var(--alternatingListColor);
  color: black;
}

.styled-table tbody tr:last-of-type {
  border-bottom: 3px solid var(--mainBlue);
}

.table-row:hover {
  background-color: #f5f5f5;
}
.button {
  display: flex;
  align-items: center;
}

</style>
